/**
 * Per-tenant visual theme.
 *
 * One Next.js instance serves every tenant (the tenant comes from the `x-tenant-id` header),
 * so a theme cannot be a build-time switch: it is resolved per request from the tenant id.
 *
 * NEXT_PUBLIC_CARES_TENANT_ID holds the tenant id(s) rendered with the UTMB Cares theme
 * (comma-separated if several). The matching class is set on <body> in `_document.tsx`
 * and consumed by `src/styles/themes/cares.scss`.
 */

export const CARES_THEME_CLASS = '-is-cares';

const caresTenantIds: string[] = (process.env.NEXT_PUBLIC_CARES_TENANT_ID ?? '')
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

export const isCaresTenant = (tenantId?: string): boolean => Boolean(tenantId && caresTenantIds.includes(tenantId));

export const getThemeClassName = (tenantId?: string): string | undefined => (isCaresTenant(tenantId) ? CARES_THEME_CLASS : undefined);
